import { render, staticRenderFns } from "./header-bg.vue?vue&type=template&id=629f555a&"
import script from "./header-bg.vue?vue&type=script&lang=js&"
export * from "./header-bg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports